import React, { Component } from 'react'
import Footer from '../../component/Footer/Footer'
import LayoutWrapper from '../../component/LayoutWrapper/'
import './MyWallet.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { transationWallet, doWalletTransationListRes } from '../../action/WalletTransationListAction'
import loaderImg from '../../assets/images/loader-example.gif';
import plusImg from "../../assets/images/plus.png";
import minusImg from "../../assets/images/minus.png";
import moment from 'moment'
import Loader from 'react-loader-advanced';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class MyWallet extends Component {

    constructor() {
        super();
        this.state = {

            isLoader: false,
            products: [
                { "id": "1000", "particulars": "Wallet amount expired on 2021-11-15", "orderid": "-", "date": "15 Nov, 2021", "amount": "- ₹50", "status": "-", "credit": "true" },
                { "id": "1008", "particulars": "Wallet amount expired on 2019-09-01", "orderid": "Order #16468877", "date": "01 Sep, 2019", "amount": "+ ₹100", "status": "-", "credit": "false" },
                { "id": "1009", "particulars": "Offer Cashback", "orderid": "-", "date": "23 Aug, 2019", "amount": "- ₹100", "status": "Valid till : 31 Aug", "credit": "true" }
            ],
            transationData: [],
            wallet_balance: 0,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    componentDidMount() {
        const data = {
            user_id: localStorage.getItem('userId')
        }
        this.props.transationWallet(data)
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.doWalletTransationListRes && nextProps.doWalletTransationListRes.user) {
            if (nextProps.doWalletTransationListRes.user && nextProps.doWalletTransationListRes.user.TransationWalletListRes) {
                if (nextProps.doWalletTransationListRes.user.TransationWalletListRes && nextProps.doWalletTransationListRes.user.TransationWalletListRes.result === true) {
                    this.setState({
                        isLoader: false,
                        wallet_balance: nextProps.doWalletTransationListRes.user.TransationWalletListRes.wallet_balance,
                        transationData: nextProps.doWalletTransationListRes.user.TransationWalletListRes.data
                    })
                } else {
                    this.setState({
                        isLoader: false,
                    })
                }
            }
        }
    }

    logOut = () => {
        localStorage.clear();
        window.location.href = '/';
    }

    particularsDetails = (data) => {
        return (
            <div className='disp-flex'>
                {data.status === "credit" ? <img src={plusImg} alt="plus" className='imgWH' /> : <img src={minusImg} alt="plus" className='imgWH' />}
                <h4 className='titleName'>{data.particulars}</h4>
            </div>
        )
    }

    dateTransation = (data) => {
        return (
            <div>
                {moment(data.date).format('DD')} {moment(data.date).format('MMM')}, {moment(data.date).format('YYYY')}
            </div>
        )
    }

    amountTransation = (data) => {
        return (
            <div>
                <i className="fa fa-rupee-sign"></i> {parseFloat(Number(data.value)).toFixed(2)}
            </div>
        )
    }

    render() {
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        const header = (
            <React.Fragment>
                <div className="p-d-flex p-jc-between p-ai-center">
                    <h5 className="title-credit">Credit Wallet Summary</h5>
                </div>
            </React.Fragment>
        );

        return (

            <React.Fragment>
                <Loader show={this.state.isLoader} message={spinner}>
                    <LayoutWrapper />

                    <main className="main">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">My Wallet</li>
                                </ol>
                            </div>
                            {/* End .container  */}
                        </nav>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9 order-lg-last dashboard-content">
                                    <h2>Stylecabbie Credit</h2>
                                    <div className='bdr-green'>
                                        <strong className="price-wallet"><i className="fa fa-rupee-sign" aria-hidden="true"></i>{this.state.wallet_balance}</strong>
                                        <span className="total-wallet">Total Wallet balance</span>
                                    </div>
                                    {/*Data Table */}
                                    <div className='mt-1'>
                                        <DataTable value={this.state.transationData} responsiveLayout="scroll" header={header} >
                                            {/* <Column field="particulars" header="PARTICULARS"  style={{ width: 400 }} ></Column> */}
                                            <Column field="orderid" header="ORDER ID" body={this.particularsDetails}></Column>
                                            <Column field="date" header="DATE" body={this.dateTransation}></Column>
                                            <Column field="value" header="AMOUNT" body={this.amountTransation}></Column>
                                            {/* <Column field='status' header="STATUS"></Column> */}
                                        </DataTable>
                                    </div>
                                </div>
                                {/* End .col-lg- */}

                                <aside className="sidebar col-lg-3">
                                    <div className="widget widget-dashboard">
                                        <h3 className="widget-title">My Wallet</h3>

                                        <ul className="list">
                                            <li><a href="/profile-update">Account Details</a></li>
                                            <li className="active">
                                                <a href="/my-wallet">My Wallet</a>
                                            </li>
                                            <li>
                                                <a href="/address-info">Address Info</a>
                                            </li>
                                            <li><a href="/change-password">Change-Password</a></li>
                                            <li><a href="/order-history">My Order</a></li>
                                            <li><a href="/corporate-order-history">Corporate Order</a></li>
                                            <li><span className="logoutLi" onClick={() => this.logOut()}>Logout</span></li>
                                        </ul>
                                    </div>
                                    {/* End .widget */}
                                </aside>
                                {/* End .col-lg-3 */}

                            </div>
                            {/* End .row */}
                        </div>
                        {/* End .container  */}
                        <div className="mb-5"></div>
                        {/* margin  */}
                    </main>
                    {/* End .main  */}
                </Loader>
                <Footer />
            </React.Fragment>
        )
    }
}

MyWallet.propTypes = {
    doWalletTransationListRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doWalletTransationListRes: doWalletTransationListRes,
});

function mapDispatchToProps(dispatch) {
    return {
        transationWallet: (data) => dispatch(transationWallet(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(MyWallet)